
import React from 'react';
import { useTranslation } from 'react-i18next';
import StarWeavers from './StarWeavers';
import DreamWeaveStats from './DreamWeaveStats';
import DreamWeave3D from './DreamWeave3D';
import LiveFeed from './LiveFeed';
import { Share2 } from 'lucide-react';

import { getFunctions, httpsCallable } from 'firebase/functions';

const DreamWeaveVisualization = () => {
    const { t } = useTranslation();
    const dreamWeaveId = 'globalDreamWeave';
    const nexusId = null;
    const functions = getFunctions();

    const handleSendSpark = async () => {
        const sendSparkFn = httpsCallable(functions, 'sendSpark');
        try {
            await sendSparkFn({ dreamWeaveId, nexusId });
        } catch (error) {
            console.error("Error sending spark:", error);
        }
    };

    const handleShare = async () => {
        const shareData = {
            title: t('dreamWeaveVisualization.share.title'),
            text: t('dreamWeaveVisualization.share.text'),
            url: window.location.href,
        };
        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                // Fallback for browsers that don't support Web Share API
                await navigator.clipboard.writeText(shareData.url);
                alert(t('dreamWeaveVisualization.share.fallback'));
            }
        } catch (error) {
            console.error('Error sharing:', error);
        }
    };

    return (
        <div className="w-full h-full bg-black text-white p-4 flex flex-col md:flex-row gap-4">
            {/* Main 3D Visualization Area */}
            <div className="flex-grow md:w-2/3 h-1/2 md:h-full bg-gray-900 rounded-lg border border-cyan-500/20 relative">
                <DreamWeave3D />
                <button
                    onClick={handleShare}
                    className="absolute top-4 left-4 bg-gray-700/50 hover:bg-gray-700 text-white font-bold p-2 rounded-full shadow-lg"
                    aria-label={t('dreamWeaveVisualization.share.ariaLabel')}
                >
                    <Share2 size={20} />
                </button>
                <button 
                    onClick={handleSendSpark}
                    className="absolute bottom-4 right-4 bg-purple-600 hover:bg-purple-500 text-white font-bold py-2 px-4 rounded-full shadow-lg animate-pulse"
                >
                    {t('dreamWeaveVisualization.sendSpark')}
                </button>
            </div>

            {/* Right Sidebar */}
            <div className="md:w-1/3 h-1/2 md:h-full flex flex-col gap-4 overflow-y-auto">
                <StarWeavers dreamWeaveId={dreamWeaveId} nexusId={nexusId} />
                <DreamWeaveStats dreamWeaveId={dreamWeaveId} nexusId={nexusId} />
                <LiveFeed dreamWeaveId={dreamWeaveId} nexusId={nexusId} />
            </div>
        </div>
    );
};

export default DreamWeaveVisualization;
